// extracted by mini-css-extract-plugin
module.exports = {"InfoText":"InfoText_InfoText__9_K3z","error":"InfoText_error__frTSB"};